/**
 * HOW TO PLAY — a POPUP over whatever is on screen, never a screen of its own (owner 21.9.2026). It used to be a
 * route with its own 2.6 MB background plate: the view you came from was torn down, a photograph of that same view
 * was downloaded, and the panel was drawn on the photograph. Now the live view stays, a dim goes over it, and the
 * panel sits on top.
 *
 * The panel, its palms, its title lane and its close × are the game's ONE shared popup element (ui/PopupPanel.tsx,
 * owner 24.9.2026) — the same element ADD FRIENDS opens in. Only the steps and GOT IT belong to this screen.
 *
 * Every number here comes from Codex's approved mockup, art/reference/vedos-howto-popup-2026-09-21.md. Claude does
 * not design this screen; it implements that document exactly.
 */
import { useEffect } from 'preact/hooks';
import { art } from '../art';
import { markHowTo } from '../state/store';
import { sfx } from '../audio/sfx';
import { PopupPanel, POPUP } from '../ui/PopupPanel';

const STEPS: [string, string][] = [
  ['ONE QUESTION, SIX STEPS', 'Everyone gets the same question. Lock your first NO WAY in secret.'],
  ['PREDICT EACH OTHER', 'Guess where each player said NO WAY. Exact = 3, one off = 1.'],
  ['THE REVEAL', 'Watch it climb, step by step, until the NO WAY.'],
  ['CALL IT', 'Once a match: bet on exact for 5 points, or nothing.'],
];

export function HowTo({ onDone }: { onDone: () => void }) {
  useEffect(() => { document.body.classList.add('lobby-cut'); return () => document.body.classList.remove('lobby-cut'); }, []);
  const done = () => { markHowTo(); sfx.select(); onDone(); };
  return (
    <div class="sheet-backdrop howto-backdrop" data-testid="howto" onClick={done}>
      <PopupPanel title="HOW TO PLAY" onClose={done} closeTestid="howto-skip" place={{ x: POPUP.x, y: POPUP.y }}>
        <ol class="ht-steps">
          {STEPS.map(([head, body], i) => (
            <li key={head} class="ht-step">
              <img class="ht-ring" src={art(`/art/howto-cut/slice/ring${i + 1}.png`)} alt={`Step ${i + 1}`} draggable={false} />
              <div class="ht-text"><h3>{head}</h3><p>{body}</p></div>
            </li>
          ))}
        </ol>

        <button class="ht-got" type="button" data-testid="howto-done" aria-label="Got it" onClick={done} style={{ '--cta': `url(${art('/art/howto-cut/slice/got-it-3slice.png')})` }}>
          <img src={art('/art/howto-cut/slice/got-it-label.png')} alt="" draggable={false} />
        </button>
      </PopupPanel>
    </div>
  );
}
